module.exports = __webpack_public_path__ + "static/media/Fichier 17.52887b16.svg";